"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authPlayerPreferencesContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.authPlayerPreferencesContract = c.router({
    getEmailPreferences: {
        method: 'GET',
        path: '/emails',
        responses: {
            200: models_1.ZPlayerPreferencesEmailSelect,
            404: c.type(),
        },
        summary: 'Get player preferences for emails contract',
    },
    setEmailPreferences: {
        method: 'POST',
        path: '/emails',
        body: models_1.ZPlayerPreferencesEmailSettings,
        responses: {
            200: utils_1.successSchema,
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Set player preferences for emails contract',
    },
}, {
    pathPrefix: '/auth',
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=playerPreferences.auth.contract.js.map